<template>
  <div class="right">
    <div class="field_left">
      <text-input id="billersurname"
                  :required="true"
                  v-model="entity.surname"
                  :disabled="!isEditable"
                  ref="surnameref"
      >
        <translate class="translate">Příjmení</translate>
      </text-input>
      <text-input id="billerfirstname"
                  :required="true"
                  v-model="entity.firstname"
                  :disabled="!isEditable"
                  ref="firstnameref"
      >
        <translate class="translate">Jméno</translate>
      </text-input>
      <select-box id="billersubjecttype"
                  v-model="entity.subject_type"
                  :options="subjectTypes"
                  :disabled="!isEditable"
      >
        <translate class="translate">Typ subjektu</translate>
      </select-box>
      <text-input
          id="billervlastniid"
          v-model="ownIdComputed"
          :disabled="!isEditable"
      >
        <translate class="translate">Vlastní ID</translate>
      </text-input>
      <text-input
          id="billerfirmaplatce"
          v-model="entity.company_name"
          :disabled="!isEditable"
      >
        <translate class="translate">Firma</translate>
      </text-input>
      <text-input
          id="billericplatce"
          v-model="entity.cin"
          :disabled="!isEditable"
      >
        <translate class="translate">IČ</translate>
      </text-input>
      <text-input
          id="billerdicplatce"
          v-model="entity.tin"
          :disabled="!isEditable"
      >
        <translate class="translate">DIČ</translate>
      </text-input>
    </div>
    <div class="field_right">
      <text-input
          id="billeremailplatce"
          v-model="entity.email"
          :disabled="!isEditable"
      >
        <translate class="translate">E-mail</translate>
      </text-input>
      <text-input
          id="billertelefonplatce"
          v-model="entity.phone"
          :disabled="!isEditable"
      >
        <translate class="translate">Telefon</translate>
      </text-input>
      <text-input
          id="billeruliceplatce"
          v-model="entity.address.street"
          :disabled="!isEditable"
      >
        <translate class="translate">Ulice a č. p.</translate>
      </text-input>
      <text-input
          id="billermestoplatce"
          v-model="entity.address.town"
          :disabled="!isEditable"
      >
        <translate class="translate">Město</translate>
      </text-input>
      <text-input
          id="billerpscplatce"
          v-model="entity.address.postal_code"
          :disabled="!isEditable"
      >
        <translate class="translate">PSČ</translate>
      </text-input>
      <select-box id="billerstatplatce"
                  v-model="entity.address.country"
                  :options="countries"
                  :disabled="!isEditable"
      >
        <translate class="translate">Stát</translate>
      </select-box>
    </div>
    <div class="field field_search">
      <multiselect-searchbox
          :searchFunction="searchTag"
          v-model="entity.tag_ids"
          :disabled="!isEditable"
      ><translate>Štítky</translate></multiselect-searchbox>
    </div>
    <textarea-input id="billerpoznamkaplatce" rows=6 cols=50
                    v-model="entity.note"
                    :disabled="!isEditable"
    >
      <translate class="translate">Poznámka</translate>
    </textarea-input>
  </div>
</template>

<script>
import TextInput from "@/components/common/TextInput"
import SelectBox from "@/components/common/SelectBox"
import TextareaInput from "@/components/common/TextareaInput"

import formFilterData from "@/components/mixins/form-filter-data"
import requiredFields from "@/components/mixins/required-fields"

export default {
  name: "BillerForm",
  components: {TextInput, TextareaInput, SelectBox},
  mixins: [formFilterData, requiredFields],
  props: {
    entity: Object,
    ownId: [String, Number],
    isEditable: Boolean,
  },
  created(TagService) {
    this.tagService = TagService
  },
  computed: {
    ownIdComputed: {
      get() {
        return this.ownId
      },
      set(newValue) {
        this.$emit('own-id-change', newValue)
      }
    },
  },
  methods: {
    validateBillerFormRequiredFields() {
      let firstnameError = null
      let surnameError = null

      if (!this.entity.firstname) {
        firstnameError = this.$gettext('Zadejte jméno')
      } else if (this.entity.firstname.length < 2) {
        firstnameError = this.$gettext('Jméno musí obsahovat min. 2 znaky')
      }

      if (!this.entity.surname) {
        surnameError = this.$gettext('Zadejte příjmení')
      } else if (this.entity.surname.length < 2) {
        surnameError = this.$gettext('Příjmení musí obsahovat min. 2 znaky')
      }

      if (firstnameError !== null) {
        this.setFieldInvalid('firstnameref', true, firstnameError)
      } else {
        this.setFieldInvalid('firstnameref')
      }

      if (surnameError !== null) {
        this.setFieldInvalid('surnameref', true, surnameError)
      } else {
        this.setFieldInvalid('surnameref')
      }
    },
    searchTag(search, selectAll = false) {
      return this.tagService.searchTagByNameAndOperatorId(this.entity.id_operator, {name_search: search, select_all: selectAll})
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/billers/BillerForm.vue